<template>
  <div class="group-detail">
    <h1 class="common__main-title">Import WeTEC Scores</h1>
    <div class="common__sub-title">Import</div>
    <div class="content-wrapper">
      <div class="main-content">
        <div class="main-content__csv-box">
          <p>wetec csv</p>
          <FileInput
            v-model="selectedCsv"
            ref="csv"
            @changedFile="error = null"
          />
          <div class="main-content__msg-box">
            <ErrorCsv :errorMessages="error" />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <b-button pill variant="primary" :disabled="isImporting" @click="confirmUploadCsv">
          Import
        </b-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import FileInput from '@/components/parts/inputItem/FileInput.vue'
import ErrorCsv from '@/components/parts/ErrorCsv.vue'
import { readCsv, countRecords } from '@/utils/csv'

export default Vue.extend({
  components: {
    FileInput,
    ErrorCsv,
  },
  data(): {
    selectedCsv: File|null,
    error: string[]|string|Object|null,
    isImporting: boolean,
    } {
    return {
      selectedCsv: null,
      error: null,
      isImporting: false,
    }
  },
  methods: {
    /**
     * CSVアップロード内容の確認を行う
     */
    async confirmUploadCsv() {
      if (this.isImporting) {
        return
      }
      if (!this.selectedCsv) {
        this.error = 'required csv file.'
        return
      }
      this.error = null

      try {
        const reader = await readCsv(this.selectedCsv)
        const recordsCount = countRecords(reader)
        const isOk = await this.$bvModal.msgBoxConfirm(
          `Import ${recordsCount} student wetecs. Is it OK?`,
        )

        if (isOk) {
          this.registerWetecs()
        }
      } catch (error) {
        this.error = 'selected file has error. please select file again.'
        this.selectedCsv = null
      }
    },
    /**
     * CSVインポートを実行しWetecの登録を行う
     */
    registerWetecs(): void {
      this.isImporting = true
      this.$store
        .dispatch('importStudentWetecsCsv', this.selectedCsv)
        .then(() => {
          this.$bvModal.msgBoxOk('Success !')
        })
        .catch((error) => {
          this.error = error
        })
        .finally(() => {
          this.isImporting = false
        })
    },
  },
})
</script>

<style scoped>
.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
  min-height: 700px;
}

.main-content p {
  display: block;
  text-align: left;
  margin: 10px 0;
  font-weight: bold;
  text-align: left;
  margin: 10px 0;
  font-weight: bold;
}

.main-content__csv-box {
  margin-bottom: 70px;
}
</style>
